import { useXHR } from "@sembark-travel/xhr"
import { UpdatePayUIntegrationCredentialsForm } from "../../../../../../Integrations"
import { Alert, Box, Container, Spinner, useId } from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import {
	generatePath,
	useNavigate,
	useParams,
} from "../../../../../../router-utils"
import useSWR from "swr"
import { isTruthy } from "@sembark-travel/ui/form"

export default function UpdatePayUIntegrationCredentialsPage() {
	const { integrationId, appId } = useParams(
		"/integrations/:integrationId/payu/:appId/update-credentials"
	)
	const xhr = useXHR()
	const id = useId()
	const { data, error } = useSWR(
		`/integrated-apps/${appId}/update-credentials?${id}`,
		() =>
			xhr
				.get<{
					data: {
						in_test_mode: boolean
					}
				}>(`/integrations/pg/${appId}/edit`)
				.then((resp) => resp.data.data)
	)
	const navigate = useNavigate()
	if (!data) {
		if (error) {
			return (
				<Alert status="error" title="Something went wrong.">
					{error.message ||
						"Failed to load credentials. Please try after sometime."}
				</Alert>
			)
		}
		return <Spinner alignCenter padding="4" />
	}
	return (
		<>
			<Helmet>
				<title>Update PayU Credentials</title>
			</Helmet>
			<Breadcrumbs
				title="Update PayU Credentials"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[
						generatePath("/integrations/:integrationId", {
							integrationId: integrationId,
						}),
						"PayU",
					],
					["", "Update Credentials"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<UpdatePayUIntegrationCredentialsForm
								isInTestMode={isTruthy(data.in_test_mode)}
								onSubmit={async (values) => {
									await xhr.post(
										"integrations/pg/" + appId + "/credentials",
										values
									)
									navigate("/integrations/:integrationId", {
										params: {
											integrationId: String(integrationId),
										},
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/integrations/:integrationId", {
										replace: true,
										params: { integrationId: integrationId },
									})
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
